import Seo from "@/components/feature/Seo";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategorySidebar from "@/pages/home/components/CategorySidebar";
import LatestMovies from "@/pages/home/components/LatestMovies";
import HotRanking from "@/pages/home/components/HotRanking";
import { homeTdk, siteInfo } from "@/mocks/site";

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title={homeTdk.title}
        description={homeTdk.description}
        keywords={homeTdk.keywords}
      />
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6">
        <div className="flex flex-col gap-8 lg:flex-row">
          <CategorySidebar />

          <div className="min-w-0 flex-1">
            <LatestMovies />
            <HotRanking />

            <section className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                关于 {siteInfo.name}
              </h2>
              <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
                {siteInfo.description}
                我们聚合海量电影资源，覆盖动作、爱情、科幻、喜剧、悬疑等丰富类型，
                提供分类筛选、关键词搜索与热度榜单，帮助您快速找到想看的高清影片。
              </p>
              <div className="mt-5 flex flex-wrap gap-6">
                {[
                  { value: "26+", label: "精选影片" },
                  { value: "10", label: "电影分类" },
                  { value: "100%", label: "免费观看" },
                ].map((stat) => (
                  <div key={stat.label}>
                    <p className="font-heading text-2xl font-extrabold text-primary-600">
                      {stat.value}
                    </p>
                    <p className="mt-1 text-xs text-foreground-500">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}